export default "__VITE_ASSET__BLQVUwAQ__"